import React, {
  useEffect,
  Fragment,
  useMemo,
  createContext,
  useReducer,
  Suspense,
  lazy,
} from "react";
import {
  BrowserRouter,
  Redirect,
  Route,
  Switch,
  useLocation,
} from "react-router-dom";
import Auth from "../auth";
import ClientApollo from "../grapqhl";
import RingLoader from "react-spinners/PuffLoader";
import { ToastProvider } from "react-toast-notifications";
export const AuthContext = createContext({});

const LayoutComponent = lazy(() => import("../../components/Layout"));
const LoginComponent = lazy(() => import("../../pages/Auth/login"));

const LoadingComponent = (props) => {
  return (
    <Fragment>
      <div
        style={{
          height: "100vh",
          width: "100vw",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <RingLoader size={60} color={"#3E83F8"} />
      </div>
    </Fragment>
  );
};

const Manipulator = (prevState, action) => {
  switch (action.type) {
    case "RESTORE_TOKEN":
      return {
        ...prevState,
        userToken: action.userToken,
        temporalToken: null,
        isLoading: false,
      };
    case "TEMPORAL_TOKEN":
      return {
        ...prevState,
        isSignout: false,
        userToken: null,
        temporalToken: action.token,
      };
    case "SIGN_IN":
      return {
        ...prevState,
        isSignout: false,
        userToken: action.token,
        temporalToken: null,
      };

    case "SIGN_OUT":
      return {
        ...prevState,
        isLoading: false,
        userToken: null,
        temporalToken: null,
        isSignout: true,
      };
    default:
      return;
  }
};

const SettingsConfig = ({ state }) => {
  return (
    <Fragment>
      <BrowserRouter>
        <Suspense fallback={LoadingComponent()}>
          <ToastProvider autoDismiss>
            <Switch>
              <Route
                component={LoginComponent}
                name={"Login"}
                path={"/login"}
                exact={true}
              />
              <Route
                name={"Home"}
                render={(props) => <LayoutComponent {...props} />}
                path={"/"}
              />

              {state.userToken === null ? (
                <Redirect to={"/login"} />
              ) : (
                <Redirect to={"/"} />
              )}
            </Switch>
          </ToastProvider>
        </Suspense>
      </BrowserRouter>
    </Fragment>
  );
};

const Configuration = () => {
  const [state, dispatch] = useReducer(Manipulator, {
    isLoading: true,
    isSignout: false,
    userToken: null,
    temporalToken: null,
  });

  useEffect(() => {
    let userToken = Auth.getCipher() === undefined ? null : Auth.getCipher();
    dispatch({ type: "RESTORE_TOKEN", userToken: JSON.parse(userToken) });
  }, []);

  const authContextController = useMemo(
    () => ({
      signIn: async (token) => {
        Auth.setCipher(JSON.stringify(token));
        dispatch({ type: "SIGN_IN", token: token });
      },
      signOut: () => {
        Auth.clearCipher();
        dispatch({ type: "SIGN_OUT" });
      },
      saveTemporalToken: (temporalToken) => {
        dispatch({
          type: "TEMPORAL_TOKEN",
          token: temporalToken,
        });
      },
    }),
    []
  );

  return (
    <Fragment>
      {state.isLoading ? (
        <LoadingComponent />
      ) : (
        <AuthContext.Provider value={[authContextController, state]}>
          <ClientApollo>
            <SettingsConfig state={state} />
          </ClientApollo>
        </AuthContext.Provider>
      )}
    </Fragment>
  );
};

export default Configuration;
